import { h, Component } from 'preact';
import { route } from 'preact-router';
import PFeed from '../../../services/prematch-feed';
import Page from '../../../services/page-data-feed';
import * as P from '../mobile-templates/tournament.jsx';
import Ticket from "../utils/ticket-logic.jsx";
import { StatsIconRegular } from '../utils/icons.jsx';
import { Pagination } from '../desktop-components/today-widget.jsx';
import { RegionFlagIcon } from '../desktop-templates/prematch-menu.jsx';
import { CardHeaderTitle } from '../desktop-templates/prematch-tournament.jsx';
import { MobileEvent } from '../mobile-pages/prematch-tournament';

import { TodayWidget as AwrabetTodayWidget, DailyEventDisplay as AwrabetDailyEventDisplay } from '../../awrabet/mobile-components/today-widget.jsx';

export class TodayWidget extends AwrabetTodayWidget {
    state = {
        tournaments: [],
        currentPage: 1,
        visibleCount: 5,
    };
    componentDidUpdate(prevProps) {
        if (this.props.sport?.id !== prevProps.sport?.id) {
            this.fetchTournaments();
        }
    }


    fetchTournaments() {
        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime();

        PFeed.getMenu((label, menu) => {
            let tournaments = [];

            if (this.props.sport && this.props.sport.id) {
                const sportData = menu[this.props.sport.id];
                if (sportData && sportData.sub) {
                    Object.values(sportData.sub).forEach(category => {
                        Object.values(category.sub).forEach(tournament => {
                            if (tournament['next-event'] <= endOfDay) {
                                tournaments.push({
                                    ...tournament,
                                    categoryOrder: category.order,
                                    tournamentOrder: tournament.order
                                });
                            }
                        });
                    });
                }
            } else {
                Object.values(menu).forEach(sport => {
                    if (sport.sub) {
                        Object.values(sport.sub).forEach(category => {
                            Object.values(category.sub).forEach(tournament => {
                                if (tournament['next-event'] <= endOfDay) {
                                    tournaments.push({
                                        ...tournament,
                                        categoryOrder: category.order,
                                        tournamentOrder: tournament.order
                                    });
                                }
                            });
                        });
                    }
                });
            }

            tournaments = tournaments.sort((a, b) => a.categoryOrder == 0 ? b.categoryOrder : a.categoryOrder - b.categoryOrder)
                .sort((a, b) => a.tournamentOrder == 0 ? b.tournamentOrder : a.tournamentOrder - b.tournamentOrder);

            const topLeagues = tournaments.filter(tournament => PFeed.mainTournaments.includes(tournament.id));
            const otherTournaments = tournaments.filter(tournament => !PFeed.mainTournaments.includes(tournament.id));

            this.setState({ tournaments: [...topLeagues, ...otherTournaments] });
        });
    }

    showMore = () => {
        this.setState({ visibleCount: this.state.visibleCount + 5 });
    };

    render({ sport, showPagination = true }) {
        const { tournaments, currentPage, visibleCount } = this.state;

        if (showPagination) {
            const displayedTournaments = tournaments.slice(0, visibleCount);
            const hasMore = visibleCount < tournaments.length;

            return (
                <div>
                    <div class="bg-slate-100">
                        {displayedTournaments.map(tournament => (
                            <TournamentDisplay tournament={tournament} key={tournament.id} />
                        ))}
                    </div>
                    {hasMore && (
                        <div class="p-4 text-center">
                            <button
                                onClick={this.showMore}
                                class="bg-custom-orange text-white px-6 py-2 rounded uppercase"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    <div class="bg-slate-100">
                        {tournaments.map(tournament => (
                            <TournamentDisplay tournament={tournament} key={tournament.id} />
                        ))}
                    </div>
                </div>
            );
        }
    }
}

// New component for displaying tournament
class TournamentDisplay extends Component {
    render() {
        const { tournament } = this.props;
        return (
            <div class="pb-0.5 bg-harif-800 text-white ">
                <div class="flex items-center py-1 gap-1">
                    <div class="pl-2">
                        <div class="h-4 w-6 flex items-center justify-center">
                            <RegionFlagIcon
                                category={PFeed.getWithParents(tournament.parent).category}
                            />
                        </div>
                    </div>
                    <CardHeaderTitle>{PFeed.getWithParents(tournament.parent).category.name} - {tournament.name}</CardHeaderTitle>
                </div>
                <DailyEventDisplay tournament={tournament} />
            </div>
        );
    }
}
export class DailyEventDisplay extends AwrabetDailyEventDisplay {
    render() {
        const { tournamentData } = this.state;
        if (!tournamentData) return <div></div>;

        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime() / 1000;
        const eventsToday = Object.values(tournamentData.sub).filter(event => event.date <= endOfDay);

        const { sport, category, tournament } = PFeed.getWithParents(this.props.tournament.id);
        const displayRuleFiltered = this.displayRuleOnlyOneMarket(tournamentData.displayRule);

        return (
            <div>
                {eventsToday.map(event => (
                    <MobileEvent
                        tournament={tournament}
                        event={event}
                        displayRuleFiltered={displayRuleFiltered}
                    />
                ))}
            </div>
        );
    }
}
